const TESTIMONIAL_SECTION_MODES = {
  MARQUEE: 'marquee',
  STATIC: 'static',
  FADE: 'fade',
};

const TESTIMONIAL_SECTION_DEFAULTS = {
  mode: TESTIMONIAL_SECTION_MODES.STATIC,
  kicker: 'Experiències reals',
  title: 'Testimonis',
  ariaLabel: 'Testimonis de persones usuàries',
};

const LANDING_TESTIMONIALS = [
  {
    quote: 'Senzill, fàcil i molt acurat. Utilitzo sempre fesmelacta per fer les meves transcripcions en català.',
  },
  {
    quote: "L'opció més còmoda i fiable que he trobat fins ara.",
  },
  {
    quote: "Utilitzo aquesta aplicació recomanada per una docent de la universitat que fa moltes transcripcions. Jo només l'he utilitzada per transcriure entrevistes d'1h 40min de durada com a màxim, en català i en castellà, i és genial: fa molt bé la transcripció, també la fa ràpidament i amb eficàcia.",
  },
  {
    quote: "Com a periodista, fesmelacta ha agilitzat d'allò més la feina transcrivint entrevistes llargues de manera ràpida i eficaç.",
  },
  {
    quote: 'Excel·lent, ha traspassat àudio a redactat en pocs segons, un arxiu de prop de dos minuts i mig. Molt útil!',
  },
  {
    quote: 'Excel·lent!',
  },
  {
    quote: 'Increïble! Superfàcil i àgil, gràcies!',
  },
  {
    quote: 'Genial.',
  },
];

function normalizeTestimonial(testimonial) {
  if (!testimonial || typeof testimonial !== 'object') {
    return null;
  }

  const normalized = {
    quote: String(testimonial.quote || '').trim(),
    author: String(testimonial.author || '').trim(),
    role: String(testimonial.role || '').trim(),
    source: String(testimonial.source || '').trim(),
    sourceUrl: String(testimonial.sourceUrl || '').trim(),
  };

  if (!normalized.quote) {
    return null;
  }

  return normalized;
}

function getPublishedTestimonials(testimonials = LANDING_TESTIMONIALS) {
  return testimonials
    .map(normalizeTestimonial)
    .filter(Boolean);
}

module.exports = {
  LANDING_TESTIMONIALS,
  TESTIMONIAL_SECTION_DEFAULTS,
  TESTIMONIAL_SECTION_MODES,
  getPublishedTestimonials,
  normalizeTestimonial,
};
